module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', [(!_vm.$route.meta.nokeepAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (_vm.$route.meta.nokeepAlive) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('v-header', {
    attrs: {
      "tabActiveIndex": 0
    }
  }), _vm._v(" "), _c('v-chater')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53908842","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 230
// module chunks = 10